import { render, staticRenderFns } from "./PCCSkeletonCard.vue?vue&type=template&id=2052a52b&scoped=true&"
import script from "./PCCSkeletonCard.vue?vue&type=script&lang=js&"
export * from "./PCCSkeletonCard.vue?vue&type=script&lang=js&"
import style0 from "./PCCSkeletonCard.vue?vue&type=style&index=0&id=2052a52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052a52b",
  null
  
)

export default component.exports